import { Component, NgZone, OnInit, ViewChild } from "@angular/core";
import { CrudService } from "src/app/services/crud.service";
import { UtilService } from "src/app/services/util.service";
import { LoadingController, AlertController, Platform } from "@ionic/angular";
import { ActivatedRoute, Router } from "@angular/router";
import { UntypedFormBuilder, UntypedFormGroup, Validators } from "@angular/forms";
import { loadingProps } from "src/utils/util.functions";
import { StarRatingComponent } from "src/app/components/star-rating/star-rating.component";

@Component({
    selector: "app-rating",
    templateUrl: "./rating.page.html",
    styleUrls: ["./rating.page.scss"],
    standalone: false
})
export class RatingPage implements OnInit {
  reservaId = '';
  public ratingForm: UntypedFormGroup;
  public reserva = {} as any;
  enableRating = true;
  disableRating = true;
  @ViewChild("myForm") mytemplateForm: StarRatingComponent;

  constructor(
    private crud: CrudService,
    private util: UtilService,
    private loadCtrl: LoadingController,
    public alertController: AlertController,
    public route: ActivatedRoute,
    public router: Router,
    private fb: UntypedFormBuilder,
    private _crudService: CrudService,
    private loadingCtrl: LoadingController,
    private platform: Platform,
    private _ngZone: NgZone,
  ) { }

  ngOnInit() {
    this.ratingForm = this.fb.group({
      pontuacao: [0, [Validators.required, Validators.min(1), Validators.max(5)]],
      reservaId: ['', Validators.required],
      foiAoRestaurante: ['', Validators.required]
    });

    this.route.params.subscribe(async (params) => {
      if (!params.id) {
        await this.router.navigate([""]);
      }
      this.reservaId = params.id;
      await this.getReservation(this.reservaId);
      //http://localhost:8100/rating/b58f8583-3a44-4b65-acda-d2e826ef55a1
    });
  }

  set wentToReservation(ev: CustomEvent) {
    this.ratingForm.get('foiAoRestaurante').patchValue(ev.detail.value);
    if (ev.detail.value === 'false') {
      this.disableRating = true;
      this.enableRating = false;
      this.ratingForm.get('pontuacao').clearValidators();
      this.ratingForm.updateValueAndValidity();
      setTimeout(() => {
        this._ngZone.run(() => {
          this.enableRating = true;
          this.ratingForm.get('pontuacao').patchValue(0);
        });
      }, 10);
    } else if (ev.detail.value === 'true') {
      this.disableRating = false;
      this.ratingForm.get('pontuacao').setValidators([Validators.required, Validators.min(1), Validators.max(5)]);
      this.ratingForm.updateValueAndValidity();
    }
  }

  private async getReservation(id: string) {
    await this.showLoading();
    this._crudService
      .getData(`restaurante/reserva/${id}`)
      .subscribe(
        async (response: any) => {
          this.reserva = response.data;
          this.ratingForm.get('reservaId').patchValue(id);
          await this.dismissLoad();
        },
        async () => {
          await this.dismissLoad();
          await this.util.showToast(
            "Error retrieving data. Please check your internet connection"
          );
        }
      );
  }

  async sendReview() {
    await this.showLoading();
    this.crud
      .postData("avaliacao", null, this.ratingForm.value)
      .subscribe(
        async (response) => {
          await this.util.showToast("Review sent successfully");
          await this.dismissLoad();
          await this.router.navigate([""]);
        },
        async (error) => {
          await this.util.showToast("Error sending review");
          await this.dismissLoad();
        }
      );
  }


  private async dismissLoad() {
    if (await this.loadingCtrl.getTop()) {
      await this.loadingCtrl.dismiss();
    }
  }

  async showLoading() {
    loadingProps.mode = this.platform.is("ios") ? "ios" : "md";
    const loading = await this.loadingCtrl.create(loadingProps);
    return await loading.present();
  }
}
